import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';
import userRoomsCollectionSaga from './sagas/userRoomsCollectionSaga';

export default [
  ...createCombineMapItem(
    'userRoomsCollection',
    createObjectCollectionReduceObject,
    [userRoomsCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/collections/reducersMap.js